var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrapper d-flex justify-content-center"},[_c('div',{staticClass:"header-container mt-0 mb-3 mb-sm-0"},[_c('h1',{staticClass:"header mb-1"},[_c('Strong',[_vm._v("Verify your identity")])],1),_c('h4',{staticClass:"sub-header"},[_vm._v("Let’s verify your identity so you can access the Autodesk network.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }